module.exports = [{"name":"Styra","capabilities":["switchBinary","switchLevel","motor","bell"]},{"name":"Övervakning","capabilities":["notificationMotion","notificationContact","notificationWater","notificationTwilight","notificationSmoke"]},{"name":"Sensorer","capabilities":["temperature","humidity","luminance"]},{"name":"Fjärrkontroller","capabilities":["notificationButton","notificationPushButton"]}]


//////////////////
// WEBPACK FOOTER
// ./src/levels.json
// module id = uYMz
// module chunks = 1